module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/nature.ab58015.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/nature.jpg
// module id = AaHk
// module chunks = 0